var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { staticClass: "ik-select", attrs: { label: _vm.name, prop: _vm.code } },
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            disabled:
              _vm.tips === "" || _vm.tips === null || _vm.tips === undefined,
            effect: "dark",
            content: _vm.tips,
            placement: "top",
          },
        },
        [
          _c(
            "el-select",
            {
              class: { require: _vm.getRequire && _vm.isNull() },
              attrs: {
                size: "small",
                disabled: _vm.disabled,
                placeholder: " -- 请选择 -- ",
                clearable: true,
              },
              on: { change: _vm.change },
              model: {
                value: _vm.val,
                callback: function ($$v) {
                  _vm.val = $$v
                },
                expression: "val",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c("el-option", {
                key: item[_vm.keyField],
                attrs: {
                  label: item[_vm.valueField],
                  value: item[_vm.keyField],
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }